import { useEffect, useState } from "react";
import "lenis/dist/lenis.css";
import "@/App.css";
import { Toaster } from "sonner";
import { initLenis, scrollToId } from "@/lib/scroll";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { About } from "@/components/site/About";
import { Workspaces } from "@/components/site/Workspaces";
import { WhyUs } from "@/components/site/WhyUs";
import { Amenities } from "@/components/site/Amenities";
import { VideoBanner } from "@/components/site/VideoBanner";
import { Locations } from "@/components/site/Locations";
import { Gallery } from "@/components/site/Gallery";
import { Contact } from "@/components/site/Contact";
import { Footer, WhatsAppFab } from "@/components/site/Footer";

function App() {
  const [prefill, setPrefill] = useState(null);

  useEffect(() => {
    const destroy = initLenis();
    return destroy;
  }, []);

  const enquire = (workspace) => {
    setPrefill({ workspace, t: Date.now() });
    scrollToId("contact");
  };
  const visit = (loc) => {
    setPrefill({ location: `${loc.name} – Sector ${loc.no}`, t: Date.now() });
    scrollToId("contact");
  };

  return (
    <div className="App grain bg-[#0B0F17] text-slate-100">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Workspaces onEnquire={enquire} />
        <WhyUs />
        <Amenities />
        <VideoBanner />
        <Locations onVisit={visit} />
        <Gallery />
        <Contact prefill={prefill} />
      </main>
      <Footer />
      <WhatsAppFab />
      <Toaster theme="dark" position="top-center" richColors />
    </div>
  );
}

export default App;
